import React, { createContext, useState, Suspense, lazy } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "./App.css";
import { projectFour, projectOne, projectThree, projectTwo } from "./FakeData/All Project/AllProject";
import { featuredProjectOne, featuredProjectThree, featuredProjectTwo } from "./FakeData/FeaturedProjects/FeaturedProjects";
import ProjectDetail from "./pages/Details/Details";
import Loader from "./pages/Shared&minifier/Loader/Loader";
import AboutMe from "./pages/AboutMe/AboutMe";
import Blogs from "./pages/Blogs/Blogs";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import NotFound from "./pages/NotFound/NotFound";
import Projects from "./pages/Projects/Projects";
import Footer from "./pages/Shared&minifier/Footer/Footer";
import Header from "./pages/Shared&minifier/Header/Header";
import ScrollTopOnRouteChange from "./pages/Shared&minifier/ScroolTopOnRouteChange/RouteChangeFromTop";
import MyTeam from "./pages/MyTeam/MyTeam";

const ActiveNavContext = createContext();
function App() {
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState("all");
  const projects = [featuredProjectThree, featuredProjectTwo, featuredProjectOne, projectOne, projectTwo, projectThree, projectFour];
  const [showing, setShowing] = useState(projects);
  const featuredProject = projects.filter((project) => project.featured === true).reverse();
  return (
    <div className="app">
      <ActiveNavContext.Provider value={{ activeCategory, setActiveCategory, projects, showing, setShowing, featured: featuredProject }}>
        <Header></Header>
        <Suspense fallback={<Loader />}>
          <AnimatePresence exitBeforeEnter>
            <Routes location={location} key={location.key}>
              <Route path="/" element={<Home></Home>}></Route>
              <Route path="/about" element={<AboutMe />}></Route>
              <Route path="/projects" element={<Projects />}></Route>
              <Route path="/projects/:route" element={<ProjectDetail />}></Route>
              <Route path="/blogs" element={<Blogs />}></Route>
              <Route path="/contact" element={<Contact />}></Route>
              <Route path="/my-team" element={<MyTeam/>}></Route>
              <Route path="*" element={<NotFound />}></Route>
            </Routes>
          </AnimatePresence>
        </Suspense>
        <Footer />
        <ScrollTopOnRouteChange />
      </ActiveNavContext.Provider>
    </div>
  );
}

export { App, ActiveNavContext };
